import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Label, Badge } from 'reactstrap';
import { Eye } from 'react-feather';

const MinigameDetailModal = ({ isOpen, toggle, minigame }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const isActive = minigame?.status === 'active';

  if (!minigame) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle} className="bg-light">
        <h5 className="mb-0">
          <Eye size={20} className="me-2" />
          Chi tiết Minigame
        </h5>
      </ModalHeader>
      <ModalBody className="p-4">
        <h4 className="mb-3">{minigame.title}</h4>
        <p className="text-muted mb-4">{minigame.description}</p>
        
        <Row>
          <Col md="6">
            <div className="mb-3">
              <Label className="fw-bold small text-muted">NGÀY BẮT ĐẦU</Label>
              <p className="mb-0">{formatDate(minigame.startDate)}</p>
            </div>
          </Col>
          <Col md="6">
            <div className="mb-3">
              <Label className="fw-bold small text-muted">NGÀY KẾT THÚC</Label>
              <p className="mb-0">{formatDate(minigame.endDate)}</p>
            </div>
          </Col>
          <Col md="6">
            <div className="mb-3">
              <Label className="fw-bold small text-muted">PHẦN THƯỞNG</Label>
              <p className="mb-0 text-warning fs-5 fw-bold">{minigame.reward || 0} điểm</p>
            </div>
          </Col>
          <Col md="6">
            <div className="mb-3">
              <Label className="fw-bold small text-muted">TRẠNG THÁI</Label>
              <p className="mb-0">
                <Badge color={isActive ? 'success' : 'secondary'} className="px-3 py-2">
                  {isActive ? '✅ Hoạt động' : '⏸️ Tạm dừng'}
                </Badge>
              </p>
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="bg-light">
        <Button color="secondary" onClick={toggle}>
          Đóng
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MinigameDetailModal;

